import React from 'react';

import classnames from 'classnames/bind';

import Layout from 'components/shared/Layout';
import CardsGrid from 'components/shared/CardsGrid';
import GradientHeaderWithIntro from 'components/shared/GradientHeaderWithIntro';
import CirclePictureContent from 'components/shared/CardWithArrowLink/CirclePictureContent';

import { CardWithArrowLinkProps } from 'components/shared/CardWithArrowLink';
import css from './styles.module.scss';
import Button from 'src/components/shared/Button';
import SmallArrow from 'src/components/icons/SmallArrow';

const cx = classnames.bind(css);

const CardsWithIntro = ({
  className,
  gradientHeader,
  intro,
  categories,
  cards,
  hasMore,
  onClick,
  bottomLink,
  onChange,
}) => {
  const customCardProps = CardWithArrowLinkProps.customCardProps;
  const handleClick = (e) => {
    e.preventDefault();
    onClick && onClick(e);
  };

  return (
    <GradientHeaderWithIntro
      gradientHeader={gradientHeader}
      intro={{
        ...intro,
      }}
      className={cx(css.CardsWithIntro, className)}
      wrapperClassName={css.container}
    >
      {cards && (
        <Layout type="wrapper" className={cx(css.wrapper, className)}>
          <Layout type="innerWrapper" className={cx(css.wrapper, className)}>
            <CardsGrid
              cards={cards}
              bottomLink={bottomLink}
              customCardComponent={CirclePictureContent}
              customCardProps={customCardProps}
            />
          </Layout>
        </Layout>
      )}
      {hasMore && (
        <Layout type="wrapper">
          {
            /**
             * This is needed to fix following issue with load more button styles: https://github.com/vercel/next.js/issues/61111
             * The duplicate should be removed when the issue is fixed.
             */
          }
          <div className={cx(css.buttonContainer)}>
            <Button
              className={cx(css.button)}
              onClick={handleClick}
              theme='gray'
              tagName='button'
            >
              See more
              <SmallArrow theme="current-color" className={css.smallArrow} />
            </Button>
          </div>
        </Layout>
      )}
    </GradientHeaderWithIntro>
  );
};

export default CardsWithIntro;
